import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';

import { Badge } from 'react-bootstrap';

import { generateColor } from "services/colors";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const LineChart = ({
    title,
    data,
    payload,
    yText,
    xText
}) => {
    // Check if data is provided and valid
    if (!data || !data.labels || !data.datasets) {
        return (
            <div className="p-4 text-center text-gray-500">
                Loading chart data or no data available...
            </div>
        );
    }

    // Prepare data for Chart.js
    const chartData = {
        labels: data.labels,
        datasets: data.datasets.map((dataset, index) => {
            const color = generateColor(index, 'statistics');
            return {
                label: dataset.dataset_label,
                data: dataset.data,
                borderColor: color,
                backgroundColor: color.replace('1)', '0.2)'),
                fill: false,
                tension: 0.1,
                pointRadius: 3,
                pointHoverRadius: 6,
            };
        }),
    };

    // Chart options
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: data.datasets.length > 1,
            },
            tooltip: {
                mode: 'index',
                intersect: false,
                callbacks: {
                    title: (tooltipItems) => {
                        const index = tooltipItems[0].dataIndex;
                        return data.tooltipLabels?.[index] ?? data.labels[index];
                    },
                },
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: xText ?? 'Period',
                    font: {
                        size: 14,
                    }
                },
                ticks: {
                    minRotation: 45,
                    maxRotation: 45,
                },
                grid: {
                    display: false,
                }
            },
            y: {
                title: {
                    display: true,
                    text: yText ?? 'Count',
                    font: {
                        size: 14,
                    }
                },
                beginAtZero: true,
                ticks: {
                    precision: 0,
                },
                grid: {
                    color: 'rgba(200, 200, 200, 0.2)',
                }
            },
        },
        interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false
        }
    };

    // className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full h-[400px] md:h-[500px]"

    return (
        <div className="card stats-container-height">
            <div className="card-header list-header no-background no-border px-2">
                <h3>{title}</h3>
            </div>
            <div className="card-body p-0 d-flex flex-column">
                <div className="d-flex gap-2 mb-2 px-2">
                    {payload.tags ? payload.tags.map((item, index) => (
                        <Badge key={index} bg="secondary" className="px-2 py-1 rounded-pill">
                            {item.name}
                        </Badge>
                    )) : null}
                </div>

                <div style={{ flex: 1, position: 'relative' }}>
                    <Line options={options} data={chartData} />
                </div>

            </div>
        </div>
    );
};

export default LineChart;